import type { Props as DialogProps } from '@studio/design-system/dialog';
import type { EventHandler } from '@studio/react-utils/event';
import type { Props as ProviderProps } from './store/index.js';
import type { Wiring as _Wiring } from '#~/common/editor/index.js';

/** Video `<Settings>` properties. */
export type Props = Omit<Omit<DialogProps, 'onBeforeClose' | 'open'> & ProviderProps, 'children'>;

/** Wiring. */
export type Wiring = _Wiring & {
  /** Calibration handler. */
  handleCalibration: EventHandler;

  /** Reboot handler. */
  handleReboot: EventHandler;

  /** Remove handler. */
  handleRemove: EventHandler;

  /** Sleep handler. */
  handleSleep: EventHandler;

  /** Undo handler. */
  handleUndo: EventHandler;

  /** Unlink handler */
  handleUnlink: EventHandler;

  /** Wake handler. */
  handleWake: EventHandler;

  /** Start egress handler. */
  handleStartEgress: EventHandler;

  /** Stop egress handler. */
  handleStopEgress: EventHandler;
};

export const SUBCATEGORY_TRIGGER_CLASSNAME =
  '!shadow-none data-[state=active]:border-b-[3px] data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:text-foreground text-muted';
